module.exports = __webpack_public_path__ + "img/COMBO WAVES BW.6cd6d13.svg";